<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
    </template>
    <a-row>
      <a-col>
        <a-button type="primary" class="button-color-cyan" @click="handleCreateSubAccount">新增渠道子账户</a-button>
      </a-col>
      <a-col>
        <BTable
          style="margin-top: 20px;"
          ref="table"
          size="default"
          :rowKey="(text, index) => index"
          :scroll="{ x: true }"
          :columns="columns"
          :data="loadData"
        >
        </BTable>
      </a-col>
    </a-row>
    <CreateSubAccount
      title="新增渠道子账户"
      ref="createSubAccount"
      :item="item"
      @success="() => { this.$refs.table.refresh(true) }"
    />
  </a-modal>
</template>

<script>
export default {
  name: 'SubAccount',
  components: {
    CreateSubAccount: () => import('./CreateChannelSubAccount')
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible: {
      handler (c) {
        if (c) {
          this.$refs.table && this.$refs.table.refresh()
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      queryParam: {},
      loadData: parameter => {
        const request = {
          channelAcctNo: this.item.channelAcctNo
          // ...this.queryParam
        }
        return this.$http.channel.channelSubAcctQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      formItemLayout: Object.freeze({
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 19
        }
      }),
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '渠道子账号',
          dataIndex: 'channelSubAcctNo' // no
        },
        {
          title: '渠道子账号名称',
          dataIndex: 'channelSubAcctName' // no
        },
        {
          title: '渠道子账号类型',
          dataIndex: 'channelSubAcctTypeDesc'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '创建人',
          dataIndex: 'createUserName'
          // needTotal: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        }
      ])
    }
  },
  created () {
  },
  methods: {
    handleCancel () {
      this.visible = false
      // this.modifyForm.resetFields()
    },
    handleCreateSubAccount () {
      this.$refs.createSubAccount.visible = true
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
